import React from "react";

import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';


import {
  Container, Grid, Box, Link, IconButton
} from "@mui/material";

const FooterApp = () => {
  return (

    <footer>
      <Box
        px={{ xs: 3, sm: 10 }}
        py={{ xs: 5, sm: 1 }}
        bgcolor="#006882"
        color="white"
      >



        <Container maxWidth="lg">
          <Grid container spacing={5} >

            <Grid item xs={12} sm={7}>


              <p> <b>© 2022 - Sons of Norway. All Rights Reserved.</b></p>
              <p>Sons of Norway, 1455 West Lake Street, Minneapolis, MN, offers financial products,
                but not all products are available in all states. Products issued by Sons of Norway
                are available to applicants who meet membership, insurability, and residency requirements.
              </p>


            </Grid>


            <Grid item xs={12} sm={5} style={{ textAlign: "right" }}>

              <IconButton style={{ color: "white" }}  href="https://www.facebook.com/sonsofnorway" >
                <FacebookIcon />
              </IconButton>

              <IconButton style={{ color: "white" }} href="https://twitter.com/sonsofnorway" >
                <TwitterIcon />
              </IconButton>

              <IconButton style={{ color: "white" }} href="https://www.youtube.com/channel/UCyqpq4zdBABNOwY-jKmcxbg" >
                <YouTubeIcon />
              </IconButton>

              <IconButton style={{ color: "white" }} href="https://www.linkedin.com/company/sons-of-norway/mycompany/verification/" >
                <LinkedInIcon />
              </IconButton>

              <IconButton style={{ color: "white" }}  href="https://www.instagram.com/sonsofnorway/">
                <InstagramIcon />
              </IconButton>

            </Grid>








          </Grid>


        </Container>
      </Box>
    </footer>

  );
};

export default FooterApp;
